export default "__VITE_ASSET__Ct025VKe__"